/** Shared localStorage expiry cleanup: never evict an unexpired owner's edits. */
export const TICKET_EDIT_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function pruneExpiredTicketStorage(): void {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, i) => localStorage.key(i));
    for (const key of keys) {
      if (!key) continue;
      const recovery = key.startsWith('ft-ticket-recovery:') || key.startsWith('ft-ticket-retained:');
      if (!recovery && !key.startsWith('alturex-tickets-offline:save:') && !['entry:', 'failure:', 'receipt:'].some((prefix) => key.startsWith('alturex-tickets-offline:' + prefix))) continue;
      try {
        const record = JSON.parse(localStorage.getItem(key) ?? 'null');
        const writtenAt = recovery ? record?.createdAt : record?.updatedAt;
        if (typeof writtenAt === 'number' && Date.now() - writtenAt >= TICKET_EDIT_MAX_AGE_MS) localStorage.removeItem(key);
      } catch { /* Unreadable storage is not evidence of expiry. */ }
    }
  } catch { /* Storage may be unavailable. */ }
}

export function isStorageQuotaError(error: unknown): boolean {
  const quota = error as { name?: string; code?: number } | null;
  return quota?.name === 'QuotaExceededError' || quota?.name === 'NS_ERROR_DOM_QUOTA_REACHED' || quota?.code === 22 || quota?.code === 1014;
}

/** Prune before writing, and once more before a single quota retry. */
export function writeTicketStorage(key: string, value: string): void {
  pruneExpiredTicketStorage();
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    if (!isStorageQuotaError(error)) throw error;
    pruneExpiredTicketStorage();
    localStorage.setItem(key, value);
  }
}
